import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { map, catchError } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { HttpClient, HttpResponse, HttpErrorResponse } from '@angular/common/http';

@Injectable()
export class OwnerUserService {

    constructor(private http: HttpClient) { }

    // Get All Owners
    public getAllOwners(pagination, sort) {

        let paginationString = '';
        paginationString += '?size=' + pagination.size;
        paginationString += '&page=' + pagination.page;

        const sortString = '&sort=' + sort;

        return this.http.get(environment.apiUrl + 'api/ext-store-owner-user' + paginationString + sortString, { observe: 'response' })
            .pipe(map(this.handleDataWithHeaders))
            .pipe(catchError(this.handleError));
    }

    // Get Owner by Owner ID
    public getOwnerById(id) {
        return this.http.get(environment.apiUrl + 'api/ext-store-owner-user/' + id)
            .pipe(map(this.handleData))
            .pipe(catchError(this.handleError));
    }

    // Create Owner
    public createOwner(obj) {
        return this.http.post(environment.apiUrl + 'api/ext-store-owner-user', obj)
            .pipe(map(this.handleData))
            .pipe(catchError(this.handleError));
    }

    // Edit Owner

    // HANDLE DATA
    private handleData(res: HttpResponse<any>) {
        const body = res;
        return body;
    }


    public handleDataWithHeaders(res: HttpResponse<any>) {

        const headers = res.headers;
        const body = res.body;
        const data = {
            'headers': headers,
            'body': body
        };
        return data;
    }


    private handleError(error: any) {
        return Observable.throw(
            new HttpErrorResponse(error)
        );
    }

}



// WEBPACK FOOTER //
// ./src/app/_services/owner-user.service.ts